import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { DynamicsBasedContactSyncSettings } from './DynamicsBasedContactSyncSettings'

export const DynamicsBasedSpecificSettings = (serviceId: IntegrationServiceId): ClickNavigationProps[] => {
  return [{ id: 'sync', label: 'Sync', content: () => <DynamicsBasedContactSyncSettings serviceId={serviceId} /> }]
}
